<template>
  <div class="rodoInfo">
    <div class="rodoInfo__contact">
      <h6 class="rodoInfo__heading">
        Inspektor Ochrony Danych
      </h6>

      <div>
        <h6 class="rodoInfo__subheading">
          Benefit Systems S.A.
        </h6>
        <a href="mailto:iod@benefitsystems.pl">iod@benefitsystems.pl</a>
      </div>

      <div>
        <h6 class="rodoInfo__subheading">
          Zdrowe Miejsce Sp. z o.o.
        </h6>
        <a href="mailto:iod@zdrofitzdrowemiejsce.pl">iod@zdrofitzdrowemiejsce.pl</a>
      </div>

      <div>
        <h6 class="rodoInfo__subheading">
          Fundacja MultiSport
        </h6>
        <a href="mailto:iod@fundacjamultisport.pl">iod@fundacjamultisport.pl</a>
      </div>
    </div>

    <div class="rodoInfo__details">
      <h6 class="rodoInfo__heading">
        Benefit Systems SA
      </h6>

      <p>
        Plac Europejski 2
      </p>

      <p>
        00-844 Warszawa
      </p>

      <p>
        Sąd Rejonowy dla m.st. Warszawy w Warszawie,
      </p>

      <p>
        XIII Wydział Gospodarczy KRS,
      </p>
      
      <p>
        nr KRS 0000370919
      </p>

      <p>
        NIP: 836-167-65-10
      </p>
      
      <p>
        REGON: 750721670
      </p>
      
      <p>
        BDO: 000558784
      </p>

      <p>
        Kapitał zakładowy: 3.301.042,00 zł, w pełni opłacony
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rodoInfo {
  display: grid;
  gap: 1.6rem;
  padding: 2.4rem 0 0 0;
  background-color: $gray-100;
  border-radius: 1.6rem;

  a {
    @include link-1;
    color: $blue-400;
  }

  &__contact {
    @include body-2-medium;
    display: grid;
    gap: 1.6rem;
  }

  &__heading {
    @include h10;
    padding-bottom: 1.2rem;
  }

  &__subheading {
    @include body-1-medium;
    display: block;
    width: 100%;
    padding-bottom: .6rem;
  }

  &__details {
    @include body-2;
    display: grid;
    gap: .8rem;
  }

  @include atXS {
    padding: 3.2rem;
  }

  @include atM {
    max-width: 80rem;
    padding: 0 6.4rem;
  }
}
</style>

